import axios from 'axios';
import { Auth } from 'aws-amplify';

const params = new URLSearchParams();
const consumerKey = process.env.REACT_APP_TOKEN_CLIENT_ID_WEB;
const consumerSecret = process.env.REACT_APP_TOKEN_CLIENT_SECRET_WEB;
const authEndpoint = process.env.REACT_APP_ACCESS_TOKEN_URL_WEB;

params.append('client_id', consumerKey);
params.append('client_secret', consumerSecret);
params.append('grant_type', 'client_credentials');

const config = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}

function getTokenService() {
  return new Promise(async (resolve) => {
    axios.post(authEndpoint, params, config).then(res => {
      resolve(res);
    }).catch(error => {
      resolve(error);
    });

  });

}
const verifySessionToken = async () => {
  await Auth.currentSession()
    .then(() => {
      console.log('get current session token in oauth');
    })
    .catch((error) => {
      console.log(error);
      logoutSessionAD();
    });

}
const logoutSessionAD = () => {
  try {
    Auth.signOut();
    removeSession();
  } catch (error) {
    console.log(error);
    removeSession();
  }
}
const removeSession = () => {
  window.sessionStorage.removeItem('username');
  window.sessionStorage.removeItem('name');
  window.sessionStorage.removeItem('user');
  window.sessionStorage.removeItem('menu');
  window.sessionStorage.removeItem('token');
  window.sessionStorage.removeItem('node');
  window.sessionStorage.removeItem('menuId');
}
export const getToken = async (verifySession) => {
  if (verifySession) { await verifySessionToken(); }
  return getTokenService().then((r) => {
    return r.data;
  });
}